import { z } from 'zod';
import { paginationSchema } from './common.js';
export const customerCreateSchema = z.object({
    companyName: z.string().min(2).max(200),
    billingEmail: z.string().email().optional(),
    contactName: z.string().max(100).optional(),
    taxId: z.string().max(50).optional(),
});
export const customerUpdateSchema = customerCreateSchema.partial();
export const customerListQuerySchema = paginationSchema.extend({
    search: z.string().max(200).optional(),
});
